import script from "./AppDataGrid.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppDataGrid.vue?vue&type=script&setup=true&lang=ts"

import "./AppDataGrid.vue?vue&type=style&index=0&id=0eccb7ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0eccb7ec"]])

export default __exports__